<template>
	<el-card>
        <div slot="header">
            <span class="top_title">库存调拨</span>
        </div>
        <div>
            <div style="margin-bottom:22px">
                <span style="padding-right:10px">日期:</span>
                <el-date-picker
                    v-model="date"
                    type="datetime"
                    placeholder="日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    style="width: 180px;padding-right:10px"
                />
            </div>
        </div>
		<SPTable ref="spt" :cols='cols' :structure="structure" @returnData="saveChange"></SPTable>
		<div class="rootbtn">
            <el-button type="primary" @click="getData" :loading="lock">确认</el-button>
		</div>
	</el-card>
</template>

<script>

import SPTable from  "../../components/table-column/supertable";
	export default {
		components: {SPTable},
		data() {
			return {
				cols: [
					{
						prop: "name",
						label: "商品",
						edit:'productEdit',
						type: "productEdit",
						width: 240,
                    },
                    {
						prop: "spec",
						label: "规格",
						edit:'',
						type: "",
						width: 130,
                    },
                    {
						prop: "store",
						label: "仓库",
						edit:'whEdit',
						type: "whEdit",
                        width: 130,
                        showName:'storename',
                        main:1,
					},
                    {
						prop: "stock",
						label: "库存",
						edit:'',
						type: "stockEdit",
						width: 130,
                    },
					{
						prop: "count",
						label: "数量("+this.$global.pack+")",
						edit:'countEdit',
						type: "countEdit",
                        width: 130,
                        unit:this.$global.pack,
                        hide:this.$global.buyType==2?true:false,
                    },
					{
						prop: "num",
						label: "数量("+this.$global.unit+")",
						edit:'numEdit',
						type: "countEdit",
                        width: 130,
                        unit:this.$global.unit,
                        hide:this.$global.buyType==1?true:false,
                    },
                    {
						prop: "enterstore",
						label: "调入仓",
						edit:'wheEdit',
						type: "whEdit",
                        width: 130,
                        showName:'estorename',
					},
                    {
						prop: "price",
						label: "价格(元)",
						edit:'',
						type: "",
                        width: 130,
                    },
                    {
						prop: "unit",
						label: "单位",
						edit:'',
						type: "unitEdit",
						width: 130,
                    },
					{
						prop: "remark",
						label: "备注",
						edit:'remarkEdit',
						type: "remarkEdit",
						min_width: 200,
						align: "center",
					},
				],
                date: this.$common.format(new Date()),
                oper:"生产入库",
                lock:false,
			}
		},
		methods: {
            structure(){
                let obj = {
                    id:0,
                    pid: '',
                    spid:'',
					spec:'',
					price: 0,
					unit: 0,
                    store: '',
                    enterstore:'',
                    storename:'',
                    estorename:'',
                    stock: '',
                    stockDesc: '',
                    negative:'',
                    count: 0,
                    name:'',
                    number:'',
                    num:0,
                    remark:'',
                    stockList:{},
                    productEdit:false,
                    whEdit:false,
                    countEdit:false,
                    numEdit:false,
                    remarkEdit:false,
                    wheEdit:false,
                }
                return obj;
            },
            getData(){
                this.lock = true;
                this.$refs.spt.getData();
            },
			saveChange(formData) {
                let obj = {
                    date:this.date,
                }
                let detail = [];
                formData.forEach(e=>{
                    let outnumber = e.count*e.unit+e.num;
                    let existnumber = 0;
                    if(e.pid>0&&outnumber>0){
                        if(e.store>0&&e.enterstore>0&&e.store!=e.enterstore){
                            let st = e.stockList[e.store];
                            if(st!=null){
                                if(st.negative==0){
                                    existnumber = st.stock;
                                }else{
                                    existnumber = 2147483647;
                                }
                            }else{
                                existnumber = 0;
                            }
                            if(outnumber<existnumber){
                                let obj1 = {
                                    pid:e.pid,
                                    spid:e.spid,
                                    unit:outnumber,
                                    outware:e.store,
                                    inware:e.enterstore,
                                    remark:e.remark,
                                    packunit:e.unit,
                                }
                                detail.push(obj1);
                            }
                        }
                    }
                })
                if(detail.length>0){
                    obj.data = JSON.stringify(detail);
                    this.$api.stockTransfer(obj).then(res=>{
                        if(res.data.code==1){
                            this.$notify({
                                title: "商品库存调拨",
                                message: "调拨成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.push("/storeDetail");
                                },
                            })
                        }else{
                            this.$common.error(res.data.msg);
                        }
                        this.$emit('cancel');
                    })
                }else{
                    this.$common.error("没有可调拨数据");
                    this.lock = false;
                }
            },
        },
	}
</script>
